/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const HandleType = {
  Target: 'target',
  Source: 'source'
} as const;
export type HandleType = (typeof HandleType)[keyof typeof HandleType];

export function instanceOfHandleType(value: any): boolean {
  for (const key in HandleType) {
    if (Object.prototype.hasOwnProperty.call(HandleType, key)) {
      if ((HandleType as Record<string, HandleType>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function HandleTypeFromJSON(json: any): HandleType {
  return HandleTypeFromJSONTyped(json, false);
}

export function HandleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): HandleType {
  return json as HandleType;
}

export function HandleTypeToJSON(value?: HandleType | null): any {
  return value as any;
}
